"use strict";
/**
 * This code was generated by generateTsPackage.
 * Do not edit it manually
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeOfferV2 = exports.getWorldsNftAddress = exports.getSellerOf = exports.getSaleStartsAt = exports.getReserveAuctionIdFor = exports.getReserveAuctionBidReferrer = exports.getReserveAuction = exports.getOfferReferrer = exports.getOffer = exports.getMinOfferAmount = exports.getMinBidAmount = exports.getMarketUtilsAddress = exports.getFoundationTreasury = exports.getFethAddress = exports.getFeesAndRecipients = exports.getFees = exports.getBuyPrice = exports.getApprovedRouterAddress = exports.createReserveAuction = void 0;
exports.createReserveAuction = {
    parseOutput: (output) => {
        return {
            /** auctionId (uint256) */
            auctionId: output[0],
        };
    },
};
exports.getApprovedRouterAddress = {
    parseOutput: (output) => {
        return {
            /** router (address) */
            router: output[0],
        };
    },
};
exports.getBuyPrice = {
    parseOutput: (output) => {
        return {
            /** seller (address) */
            seller: output[0],
            /** price (uint256) */
            price: output[1],
        };
    },
};
exports.getFees = {
    parseOutput: (output) => {
        return {
            /** protocolFeeAmount (uint256) */
            protocolFeeAmount: output[0],
            /** creatorRecipients (address payable[]) */
            creatorRecipients: output[1],
            /** creatorShares (uint256[]) */
            creatorShares: output[2],
            /** sellerRev (uint256) */
            sellerRev: output[3],
            /** buyReferrerFee (uint256) */
            buyReferrerFee: output[4],
            /** sellerReferrerFee (uint256) */
            sellerReferrerFee: output[5],
        };
    },
};
exports.getFeesAndRecipients = {
    parseOutput: (output) => {
        return {
            /** totalFees (uint256) */
            totalFees: output[0],
            /** creatorRev (uint256) */
            creatorRev: output[1],
            /** creatorRecipients (address payable[]) */
            creatorRecipients: output[2],
            /** creatorShares (uint256[]) */
            creatorShares: output[3],
            /** sellerRev (uint256) */
            sellerRev: output[4],
            /** seller (address payable) */
            seller: output[5],
        };
    },
};
exports.getFethAddress = {
    parseOutput: (output) => {
        return {
            /** fethAddress (address) */
            fethAddress: output[0],
        };
    },
};
exports.getFoundationTreasury = {
    parseOutput: (output) => {
        return {
            /** treasuryAddress (address payable) */
            treasuryAddress: output[0],
        };
    },
};
exports.getMarketUtilsAddress = {
    parseOutput: (output) => {
        return {
            /** marketUtilsAddress (address) */
            marketUtilsAddress: output[0],
        };
    },
};
exports.getMinBidAmount = {
    parseOutput: (output) => {
        return {
            /** minimum (uint256) */
            minimum: output[0],
        };
    },
};
exports.getMinOfferAmount = {
    parseOutput: (output) => {
        return {
            /** minimum (uint256) */
            minimum: output[0],
        };
    },
};
exports.getOffer = {
    parseOutput: (output) => {
        return {
            /** buyer (address) */
            buyer: output[0],
            /** expiration (uint256) */
            expiration: output[1],
            /** amount (uint256) */
            amount: output[2],
        };
    },
};
exports.getOfferReferrer = {
    parseOutput: (output) => {
        return {
            /** referrer (address payable) */
            referrer: output[0],
        };
    },
};
exports.getReserveAuction = {
    parseOutput: (output) => {
        return {
            /** auction (struct ReserveAuction) */
            auction: output[0],
        };
    },
};
exports.getReserveAuctionBidReferrer = {
    parseOutput: (output) => {
        return {
            /** referrer (address payable) */
            referrer: output[0],
        };
    },
};
exports.getReserveAuctionIdFor = {
    parseOutput: (output) => {
        return {
            /** auctionId (uint256) */
            auctionId: output[0],
        };
    },
};
exports.getSaleStartsAt = {
    parseOutput: (output) => {
        return {
            /** saleStartsAt (uint256) */
            saleStartsAt: output[0],
        };
    },
};
exports.getSellerOf = {
    parseOutput: (output) => {
        return {
            /** seller (address payable) */
            seller: output[0],
        };
    },
};
exports.getWorldsNftAddress = {
    parseOutput: (output) => {
        return {
            /** worldsNft (address) */
            worldsNft: output[0],
        };
    },
};
exports.makeOfferV2 = {
    parseOutput: (output) => {
        return {
            /** expiration (uint256) */
            expiration: output[0],
        };
    },
};
//# sourceMappingURL=NFTMarketHelpers.generated.js.map